import "../../static/css/login.css";
import Loading from "../Loading.tsx";
import {useTranslation} from 'react-i18next';
import SignUpAndFindAccountBlock from "./SignUpAndFindAccountBlock.tsx";
import {Navbar} from "../../components/Navbar.tsx";
import StandAloneLogo from "./StandAloneLogo.tsx";
import {type FC, type FormEvent, type ReactNode, useCallback, useContext, useEffect, useState} from "react";
import {swal_util} from "../../lib/SwalUtil.ts";
import {membership} from "../../lib/Membership.ts";
import {BlueshiftAPIConnectorUnknownError} from "../../lib/api.ts";
import AuthContext from "../../components/AuthContext.ts";
import {useNavigate} from "react-router-dom";
import {frontEndType} from "../../build_constants.ts";
import {FRONT_END_TYPE} from "../../constants.ts";


interface ContentProps {
    toggleSidebar?: () => void;
    redirectPage: string;
}

const FindAccountMain: FC<{ children: ReactNode }> = ({children}) => {

    if (frontEndType == FRONT_END_TYPE.XSLAB) {
        return (
            <main id="login" className="container-wide">
                {children}
            </main>
        );
    }

    return (
        <main id="login-main" className="d-block vh-100">
            <StandAloneLogo/>
            {children}
        </main>
    );
}

const FindAccount = ({redirectPage, toggleSidebar}: ContentProps) => {
    const {t} = useTranslation('ui');
    const [loading, setLoading] = useState(false);

    const authContext = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (authContext?.isAuthenticated) {
            const navigateState = {from: {pathname: location.pathname, search: location.search, hash: location.hash}};
            navigate(redirectPage, {replace: true, state: navigateState});
        }

    }, [redirectPage, authContext, navigate]);

    const onSubmitLoginForm = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const frmData = new FormData(e.currentTarget);
        const email = frmData.get("email") as string;

        if (!email) {
            swal_util.show_error(t("signUp.error.enterEmail")).finally();
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            swal_util.show_error(t("signUp.error.invalidEmail")).finally();
            return false;
        }

        try {
            setLoading(true);
            await membership.reset(email);
        } catch (e) {
            setLoading(false);
            if (e instanceof BlueshiftAPIConnectorUnknownError) {
                await swal_util.show_error(e.message);
                return false
            }

            throw e;
        }

        setLoading(false);
        await swal_util.show_info(t("findAccount.pleaseWaitAMomentAndCheckYourEmail"));

        return true;
    }, [t]);


    return (
        <>
            {loading && <Loading text={t("findAccount.yourAccountInformationIsBeingSentViaEmail")}/>}
            {
             <FindAccountMain>
                    <Navbar toggleSidebar={toggleSidebar}/>

                    <article className="" id="wrapper">
                        <div className="content section core-value row row-heading justify-content-between">

                            <div className="col-sm-auto col-heading col-12 col-md-6">
                                <div className="section-heading text-sm-left is-visible">
                                <h4 id="">{t("login.welcomeBack")}</h4>
                                <h2 className=""> {t("findAccount.findAccount")}</h2>
                                </div>
                            </div>

                            <div className="form-box col-12 col-md-6">
                                <form className="custom-validation" id="form_login" action="#"
                                      onSubmit={onSubmitLoginForm}>
                                    <div className="mt-4">
                                        <input type="text"
                                               name="email"
                                               className="form-control rounded-pill px-4"
                                               placeholder={t("signUp.emailPlaceholder")}
                                               autoComplete="username"/>
                                    </div>

                                    <div className="mt-3 d-grid">
                                        <button className="button_blue" type="submit">{t("findAccount.findAccount")}</button>
                                    </div>

                                    <SignUpAndFindAccountBlock disableSignup={true}/>
                                </form>
                            </div>
                        </div>
                    </article>
                    </FindAccountMain>
            }
        </>
    );
}


export default FindAccount;